import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  selected,
  onSelect,
  mode = "single",
  ...props
}) {
  const [currentMonth, setCurrentMonth] = React.useState(
    selected ? new Date(selected) : new Date()
  )

  const daysInMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0
  ).getDate()

  const firstDayOfMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1
  ).getDay()

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ]

  const dayNames = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]

  const handlePrevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))
  }

  const handleNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))
  }

  const handleDateClick = (day) => {
    const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day)
    if (onSelect) {
      onSelect(date)
    }
  }

  const isSelected = (day) => {
    if (!selected) return false
    const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day)
    return selected.toDateString() === date.toDateString()
  }

  const days = []
  for (let i = 0; i < firstDayOfMonth; i++) {
    days.push(<div key={`empty-${i}`} className="p-0 text-center text-sm" />)
  }

  for (let day = 1; day <= daysInMonth; day++) {
    days.push(
      <Button
        key={day}
        type="button"
        onClick={() => handleDateClick(day)}
        variant={isSelected(day) ? "default" : "ghost"}
        className={cn(
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100",
          isSelected(day) && "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground"
        )}
      >
        {day}
      </Button>
    )
  }

  return (
    <div className={cn("p-3 bg-card-bg rounded-md", className)} {...props}>
      <div className="flex items-center justify-between mb-4">
        <Button
          type="button"
          variant="outline"
          className="h-7 w-7 p-0 bg-transparent"
          onClick={handlePrevMonth}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <div className="text-sm font-medium">
          {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
        </div>
        <Button
          type="button"
          variant="outline"
          className="h-7 w-7 p-0 bg-transparent"
          onClick={handleNextMonth}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
      <div className="grid grid-cols-7 gap-1">
        {dayNames.map((name) => (
          <div key={name} className="text-center text-xs font-medium text-muted-foreground mb-1 h-9 flex items-center justify-center">
            {name}
          </div>
        ))}
        {days}
      </div>
    </div>
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
